import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { FloatingLabel } from 'react-bootstrap';
import TinymceEditor from 'components/common/TinymceEditor';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { useDropzone } from 'react-dropzone';
import Flex from 'components/common/Flex';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { useCallback } from 'react';
import CurrencyInput from './CurrencyInput';
import CreatableSelect from 'react-select/creatable';

import { Button } from 'react-bootstrap';
import { BsClipboard } from 'react-icons/bs';
import './styles.css';
import DirectoryService from '../directory/DirectoryService';
import SettingsService from '../directory/SettingsService';
// Custom Hook for generating forms
function useFormGenerator(
  jsonSchema,
  handleSubmitCallBack,
  initialValues = {},
  setValidatedCallBack
) {
  const stringToDate = s => {
    return new Date(s);
  };
  // Create state to store form data
  const [formData, setFormData] = useState(initialValues);
  // Handle form field changes
  const handleChange = event => {
    const { name, value } = event.target;

    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleCopyToClipboard = async name => {
    const value = formData[name];
    if (!value) return;

    await navigator.clipboard.writeText(value);
  };
  const isEditable = field => {
    return field.notEditable == undefined || field.notEditable !== true;
  };
  const getFieldValue = (field, formData) => {
    if (field.computed && typeof field.computedValue === 'function') {
      return field.computedValue(formData);
    }
    return formData[field.name] || '';
  };
  const validateEmail = field => {
    if (!isFieldRequired(field)) {
      return true;
    }
    const value = formData[field.name];
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
      console.log('Invalid email format');
      return false;
    } else {
      console.log('Valid email:', value);
      return true;
    }
  };
  const validateSelectValues = field => {
    if (!isFieldRequired(field)) {
      return true;
    }
    if (
      formData[field.name] ||
      (field.isMulti &&
        formData[field.name] !== undefined &&
        formData[field.name].length > 0)
    ) {
      return true;
    }
    return false;
  };
  // Handle form submission
  const handleSubmit = event => {
    event.preventDefault();
    // event.stopPropagation();
    const form = event.currentTarget;
    console.log(form.checkValidity());
    setValidatedCallBack(true);
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      try {
        console.log('Form Data:', formData);
        handleSubmitCallBack(formData);
      } catch (error) {
        console.error('Error saving', error);
      }
    }
  };

  const isFieldRequired = field => {
    console.log(field);
    if (field.required !== undefined && field.required === true) {
      return true;
    }
    return false;
  };

  const generateFormControl = field => {
    const hideFormControl = field.hidden !== undefined && field.hidden === true && DirectoryService.isLoggedUserRoot();
    if (field.type === 'checkbox') {
      const [isChecked, setIsChecked] = useState(formData[field.name]);
      return (
        <>
        {hideFormControl && (<Form.Check
          type="switch"
          id={field.name}
          name={field.name}
          label={field.label}
          checked={isChecked || field.isChecked}
          onChange={() => {
            setFormData({ ...formData, [field.name]: !isChecked });
            setIsChecked(!isChecked);
            console.log(formData);
          }}
        ></Form.Check>)}
        </>

      );
    }
    if (field.type === 'fileUploader') {
      const [acceptedFiles, setAcceptedFiles] = useState([]);
      console.log(formData[field.name]);
      console.log(formData);
      const sizeMb = field.maxSize || 5;

      const onDrop = useCallback(acceptedFiles => {
        // Update the state with the accepted files
        const updatedAcceptedFiles = acceptedFiles.map(file =>
          Object.assign(file, {
            preview: URL.createObjectURL(file)
          })
        );
        setAcceptedFiles(updatedAcceptedFiles);
        setFormData(prevFormData => ({
          ...prevFormData,
          [field.name]: acceptedFiles[0]
        }));

      }, []);
      const { getRootProps, getInputProps } = useDropzone({
        maxSize: sizeMb * 1024 * 1024,
        onDrop
      });
      let downloadPath = '';
      if (typeof formData[field.name] === 'string') {
        downloadPath = formData[field.name];
      }
      const files = acceptedFiles.map(file => (
        <li key={file.path}>
          {file.path} - {file.size} bytes
        </li>
      ));
      const previewFiles = acceptedFiles.map(file => (
        <div key={file.name} >
          <img
            src={file.preview}
            width={100}
            onLoad={() => URL.revokeObjectURL(file.preview)}
            alt={file.name}
          />
        </div>
      ));
      return (
        <Form.Group className="mb-3" controlId={field.name}>
          {downloadPath !== '' && <a href={downloadPath}>Download file</a>}
          <br />
          <Form.Label cclassName="fs--1">{field.label}</Form.Label>
          <div {...getRootProps({ className: 'dropzone-area py-6' })}>
            <input
              {...getInputProps({ multiple: field.multiple })}
              name={field.name}
            />
            <Flex justifyContent="center">
              <img src={cloudUpload} alt="" width={25} className="me-2" />
              <p className="fs-0 mb-0 text-700">Drop your file here</p>
            </Flex>
          </div>
          <div className="mt-3">
            {acceptedFiles.length > 0 && !field.preview && (
              <>
                <h6>File</h6>
                <ul>{files}</ul>
              </>
            )}
            {acceptedFiles.length > 0 && field.preview && (
              <>
              {previewFiles} 
              </>)}  
          </div>
        </Form.Group>
      );
    }
    if (field.type === 'daypicker') {
      console.log(formData[field.name]);
      const filterPassedTime = time => {
        const currentDate = new Date(time);
        const hours = currentDate.getHours();
        const minutes = currentDate.getMinutes();
        // Show times from 8:00 AM to 6:00 PM (18:00) inclusive
        return hours >= 8 && (hours < 18 || (hours === 18 && minutes === 0));
      };
      // Only convert to date if value exists and is valid
      const selectedDate = formData[field.name]
        ? stringToDate(formData[field.name])
        : null;
      return (
        <Form.Group className="mb-2" controlId={field.name}>
          <Form.Label>{field.label}</Form.Label>
          <br />
          <DatePicker
            selected={selectedDate}
            onChange={date => {
              setFormData({ ...formData, [field.name]: date });
            }}
            required
            className="form-control"
            placeholderText={field.placeholder || 'Select date'}
            dateFormat={field.pattern || 'dd/MM/yyyy h:mm aa'}
            showTimeSelect
            timeIntervals={30}
            name={field.name}
            value={formData[field.name]}
            filterTime={filterPassedTime}
          />
          <Form.Control.Feedback type="invalid">
            Please a valide start date for the event
          </Form.Control.Feedback>
        </Form.Group>
      );
    }
    if (field.type === 'textarea') {
      return (
        <Form.Group className="mb-3" controlId={field.name}>
          <Form.Label>{field.label}</Form.Label>
          <Form.Control
            as="textarea"
            rows={field.rows || 3}
            size="sm"
            id={field.name}
            style={{ height: 'auto', fontSize: '0.875rem' }}
            name={field.name}
            type={field.type}
            tabIndex={field.tabIndex}
            disabled={field.disabled}
            required={isFieldRequired(field)}
            value={getFieldValue(field, formData)}
            onChange={handleChange}
          />
        </Form.Group>
      );
    }
    if (field.type === 'currency') {
      console.log('Currency field:', field);
      return (
        <Form.Group className="mb-3" controlId={field.name}>
          <Form.Label>{field.label}</Form.Label>
          <CurrencyInput
            id={field.name}
            name={field.name}
            value={getFieldValue(field, formData)}
            className={isFieldRequired(field) ? 'is-valid' : 'is-invalid'}
            placeholder="Enter amount"
            onChange={value => {
              setFormData({ ...formData, [field.name]: value });
            }}
            currency={field.currency === 'gbp' ? '£' : '$'}
            required={isFieldRequired(field)}
            disabled={field.disabled || false}
          />
          <Form.Control.Feedback type="invalid">
            {field.label + ' required'}
          </Form.Control.Feedback>
        </Form.Group>
      );
    }
    if (field.type === 'creatableselect') {
      return (
        <Form.Group className="mb-3" controlId={field.name}>
          <Form.Label>{field.label + ' *'}</Form.Label>
          <CreatableSelect
            isMulti={field.isMulti}
            options={field.options} // your default list
            value={formData[field.name] || []}
            onChange={value => {
              setFormData({ ...formData, [field.name]: value });
            }}
          />
        </Form.Group>
      );
    }
    if (field.type === 'multiselect') {
      return (
        <Form.Group
          className="mb-3"
          controlId={field.name}
          style={{ maxWidth: field.maxWidth || '100%' }}
        >
          <Form.Label>{field.label}</Form.Label>
          <Select
            closeMenuOnSelect={false}
            name={field.name}
            key={field.name}
            options={field.options}
            placeholder="Select..."
            required={isFieldRequired(field)}
            isMulti={field.isMulti}
            classNames={'form-control-sm'}
            classNamePrefix="react-select"
            value={formData[field.name] || ''}
            onChange={value => {
              setValidatedCallBack(validateSelectValues(field));
              setFormData({ ...formData, [field.name]: value });
            }}
            className={validateSelectValues(field) ? 'is-valid' : 'is-invalid'}
          />
          <Form.Control.Feedback type="invalid">
            {field.label + ' required'}
          </Form.Control.Feedback>
        </Form.Group>
      );
    }
    if (field.type === 'editor') {
      return (
        <Form.Group className="mb-3" controlId={field.name}>
          <Form.Label>{field.label}</Form.Label>
          <TinymceEditor
            handleChange={value => {
              const customEvent = {
                target: { name: field.name, value: value }
              };
              handleChange(customEvent);
            }}
            name={field.name}
            value={formData[field.name]}
            required={isFieldRequired(field)}
          />
        </Form.Group>
      );
    }
    if (field.type === 'email') {
      return (
        <FloatingLabel label={field.label} className="mb-2">
          {console.log(formData)}
          <Form.Control
            size="sm"
            id={field.name}
            name={field.name}
            type={field.type}
            tabIndex={field.tabIndex}
            placeholder="Enter a valid email"
            required={isFieldRequired(field)}
            value={formData[field.name] || ''}
            onChange={handleChange}
            className={validateEmail(field) ? 'is-valid' : 'is-invalid'}
          />
        </FloatingLabel>
      );
    }
    if (field.type === 'range') {
      return (
        <Form.Group className="mb-3" controlId={field.name}>
          <Form.Label>
            {field.label}: {formData[field.name]}
          </Form.Label>
          <br />
          <Form.Range
            name={field.name}
            min={field.min || 1}
            max={field.max || 5}
            step={field.step || 1}
            value={formData[field.name] || 0}
            style={{ maxWidth: field.maxWidth || '100%' }}
            onChange={handleChange}
            required={isFieldRequired(field)}
          />
        </Form.Group>
      );
    }
    return (
      <Form.Group controlId={field.name} className="mb-3">
        <Form.Label>{field.label}</Form.Label>
        <div
          className="input-group input-group"
          style={{ maxWidth: field.maxWidth || '100%' }}
        >
          <Form.Control
            size="sm"
            style={{ maxWidth: field.maxWidth || '100%' }}
            id={field.name}
            name={field.name}
            type={field.type}
            tabIndex={field.tabIndex}
            disabled={field.disabled}
            required={isFieldRequired(field)}
            value={getFieldValue(field, formData)}
            onChange={handleChange}
          />
          {field.copyToClipBoard && (
            <Button
              size="sm"
              onClick={() => handleCopyToClipboard(field.name)}
              disabled={!formData[field.name]}
              title="Copy to clipboard"
            >
              <BsClipboard />
            </Button>
          )}
        </div>
      </Form.Group>
    );
  };
  // Generate form fields based on JSON schema
  const generateFormFields = () => {
    return jsonSchema.map(field => {
      if (field.type === 'group') {
        return (
          <Row className="g-3" key={field.fields.map(f => f.name).join('-')}>
            {field.fields.map(f => {
              
              if (isEditable(f)) {
                return (
                  <Col xs={12} md key={f.name}>
                    {generateFormControl(f)}
                  </Col>
                );
              }
            })}
          </Row>
        );
      } else {
        if (isEditable(field)) {
          return (
            <Row className="g-2" key={field.name}>
              <Col xs={12} md key={field.name}>
                {generateFormControl(field)}
              </Col>
            </Row>
          );
        }
      }
    });
  };

  // Return the form fields, handleSubmit, and handleChange
  return {
    formFields: generateFormFields(),
    handleSubmit,
    handleChange
  };
}

export default useFormGenerator;
